import { NotificationIcons, NotificationStatuses } from "@Front-end/ui/models/notifications";

export const notificationIcons: NotificationIcons = {
    [NotificationStatuses.Info]: "check",
    [NotificationStatuses.Warning]: "warning",
    [NotificationStatuses.Success]: "check",
    [NotificationStatuses.Error]: "error",
};
